export const templateSorveteria = {

config:{
cor_primaria:"#ff69b4"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"ICE CREAM",
pos_x:100,
pos_y:40,
estilo:{fontSize:32,color:"#fff"}
},

{
id:2,
tipo:"texto",
conteudo:"CASQUINHA",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"R$ 5",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
}

]

};